import { createActionName } from "../../../utility"

export const reducerName = "folders"

export const FOLDER = createActionName(reducerName, "FOLDER")
export const FOLDERS = createActionName(reducerName, "FOLDERS")
